import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials } from '../store/slices/authSlice';
import { fetchPermissions } from '../store/slices/permissionsSlice';
import { login as loginApi } from '../services/authService';
import { PERMISSIONS } from '../constants/permissions';

export default function useLoginForm() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            const res = await loginApi({
                email,
                password,
                remember_me: remember ? 1 : 0,
            });

            // Store tokens
            localStorage.setItem('access_token', res.data.access_token);
            localStorage.setItem('refresh_token', res.data.refresh_token);

            // Set auth credentials
            dispatch(setCredentials({
                accessToken: res.data.access_token,
                refreshToken: res.data.refresh_token,
            }));

            // Fetch user permissions after successful login
            try {
                await dispatch(fetchPermissions()).unwrap();
            } catch (permissionError) {
                console.error('Failed to fetch permissions:', permissionError);
                // Continue even if permissions fail - Login component will handle navigation
            }

            // Don't navigate here - let the Login component handle navigation based on permissions
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return {
        email,
        setEmail,
        password,
        setPassword,
        remember,
        setRemember,
        handleSubmit,
        loading,
        error,
    };
} 